import { render, staticRenderFns } from "./ROTNewPopup.vue?vue&type=template&id=712cf2ba&scoped=true&"
import script from "./ROTNewPopup.vue?vue&type=script&lang=js&"
export * from "./ROTNewPopup.vue?vue&type=script&lang=js&"
import style0 from "./ROTNewPopup.vue?vue&type=style&index=0&id=712cf2ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712cf2ba",
  null
  
)

export default component.exports